<section *ngIf="maintenance.active" class="app-maintenance" role="dialog" aria-modal="true"
  aria-labelledby="maintenance-title" aria-describedby="maintenance-description"
  cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
  <div class="app-maintenance-card">
    <div class="app-maintenance-brand">Snöball</div>
    <h1 id="maintenance-title">We’ll be back soon</h1>
    <p id="maintenance-description">Snöball is temporarily unavailable while we complete scheduled maintenance. Please try again shortly.</p>
    <button type="button" class="btn btn-primary" cdkFocusInitial (click)="maintenance.retry()">Try again</button>
  </div>
</section>
<div [style.display]="maintenance.active ? 'none' : null" [attr.inert]="maintenance.active ? '' : null">
<a class="sn-skip-link" href="#sn-main" (click)="skipToMain($event)">Skip to main content</a>
<app-env-bar
  [showDetailsLink]="!!currentUser"
  [impersonatedName]="impersonatedName"
  (revertImpersonation)="revertImpersonation()"></app-env-bar>
<div class="app-top-chrome">

  <div #appAlertStack class="app-alert-stack">
    <div *ngIf="currentUser && sessionExpiryWarning" class="app-top-alert alert alert-warning text-center"
      role="alert">
      {{ (sessionExpiryWarning.reason === 'absolute_timeout'
        ? 'AuthSecurity.absolute_timeout_warning'
        : 'AuthSecurity.idle_timeout_warning')
        | translate:{time: formatSessionRemaining(sessionExpiryWarning.remainingSeconds)} }}
    </div>

    <div *ngIf="currentUser && passwordExpiryWarning" class="app-top-alert alert alert-warning text-center"
      role="alert">
      {{ 'AuthSecurity.password_expiry_warning' | translate:{date: (passwordExpiryWarning.expires_at | date:'medium')} }}
      <button class="btn btn-sm btn-primary ml-2" type="button" (click)="openPasswordSettings()">
        {{ 'AuthSecurity.change_password' | translate }}
      </button>
    </div>

    <div *ngIf="currentUser && mfaAdvisory" class="app-top-alert alert alert-warning text-center"
      role="alert">
      <ng-container *ngIf="mfaAdvisoryHasDeadline; else mfaAdvisoryNow">
        {{ 'AuthSecurity.mfa_advisory' | translate:{days: mfaAdvisory.daysRemaining} }}
      </ng-container>
      <ng-template #mfaAdvisoryNow>{{ 'AuthSecurity.mfa_advisory_now' | translate }}</ng-template>
      <button class="btn btn-sm btn-primary ml-2" type="button" (click)="openSecurity()">
        {{ 'AuthSecurity.setup_mfa' | translate }}
      </button>
      <button *ngIf="!mfaAdvisory.dismissible" class="btn btn-sm btn-outline-secondary ml-2"
        type="button" (click)="logout()">{{ 'AuthSecurity.logout' | translate }}</button>
      <button *ngIf="mfaAdvisory.dismissible" class="close" type="button"
        aria-label="Dismiss" (click)="dismissMfaAdvisory()"><span aria-hidden="true">&times;</span></button>
    </div>
  </div>

  <app-nav-header></app-nav-header>
</div>

<app-nav-sidebar></app-nav-sidebar>

<main id="sn-main" class="sn-app-main" tabindex="-1">
  <router-outlet></router-outlet>
</main>

<app-nav-command-palette></app-nav-command-palette>

<!--- commit: {{versionInfo.build_number}} date: {{versionInfo.build_date}} --->
<div class="footer">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="footer-menu">
          <div>
            <ul>
              <li>
                <a href="https://snoball.events" target="_blank" class="copyright">
                  &copy; Snöball
                </a>
              </li>
              <li>
                <a href="https://snoball.events/book-demo3/" target="_blank">
                  Get in Touch
                </a>
              </li>
              <li>
                <a href="https://i.snoball.it/b/privacy" target="_blank">
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
